export default {
  GeoItemSearchComment: require('./GeoItemSearchComment').default,
  GeoItemSearchLandApEmergency: require('./GeoItemSearchLandApEmergency').default,
  GeoItemSearchJunkaiTenkenReportTenkenData: require('./GeoItemSearchJunkaiTenkenReportTenkenData').default,
  GeoItemSearchLandAiDetections: require('./GeoItemSearchLandAiDetections').default,
};
